import {
  collection,
  getCountFromServer,
  query,
  where,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import dayjs, { Dayjs } from 'dayjs';
import countScheduledMessages from '../jobs/countScheduledMessages';

async function getSMSStats(date: Dayjs): Promise<{
  [key: string]: { planned: number; sent: number; received: number };
}> {
  try {
    const stats: {
      [key: string]: { planned: number; sent: number; received: number };
    } = {
      '00h-01h': { planned: 0, sent: 0, received: 0 },
      '01h-02h': { planned: 0, sent: 0, received: 0 },
      '02h-03h': { planned: 0, sent: 0, received: 0 },
      '03h-04h': { planned: 0, sent: 0, received: 0 },
      '04h-05h': { planned: 0, sent: 0, received: 0 },
      '05h-06h': { planned: 0, sent: 0, received: 0 },
      '06h-07h': { planned: 0, sent: 0, received: 0 },
      '07h-08h': { planned: 0, sent: 0, received: 0 },
      '08h-09h': { planned: 0, sent: 0, received: 0 },
      '09h-10h': { planned: 0, sent: 0, received: 0 },
      '10h-11h': { planned: 0, sent: 0, received: 0 },
      '11h-12h': { planned: 0, sent: 0, received: 0 },
      '12h-13h': { planned: 0, sent: 0, received: 0 },
      '13h-14h': { planned: 0, sent: 0, received: 0 },
      '14h-15h': { planned: 0, sent: 0, received: 0 },
      '15h-16h': { planned: 0, sent: 0, received: 0 },
      '16h-17h': { planned: 0, sent: 0, received: 0 },
      '17h-18h': { planned: 0, sent: 0, received: 0 },
      '18h-19h': { planned: 0, sent: 0, received: 0 },
      '19h-20h': { planned: 0, sent: 0, received: 0 },
      '20h-21h': { planned: 0, sent: 0, received: 0 },
      '21h-22h': { planned: 0, sent: 0, received: 0 },
      '22h-23h': { planned: 0, sent: 0, received: 0 },
      '23h-00h': { planned: 0, sent: 0, received: 0 },
    };

    const db = firestore;
    const smsCollection = collection(db, FirestoreCollections.sms);

    let startHour;

    if(date.isSame(dayjs(), 'day')) {
      startHour = date.startOf('hour');
    } else {
      startHour = date.startOf('day');
    }

    for (let i = startHour.hour(); i < 23; i++) {
      const start = startHour.add(i - startHour.hour(), 'hour');
      const end = start.clone().add(1, 'hour');

      const hours = start.hour() > 9 ? start.hour() : `0${start.hour()}`;
      const nextHours = end.hour() > 9 ? end.hour() : `0${end.hour()}`;
      const interval = `${hours}h-${nextHours}h`;

      countScheduledMessages([
        where('timestamp', '>=', start.toDate().getTime()),
        where('timestamp', '<', end.toDate().getTime()),
      ]).then((count) => {
        const stat = stats[interval] || { planned: 0, sent: 0, received: 0 };
        stat.planned = count;
        stats[interval] = stat;
      });
    }

    // SMS sent and received
    const startOfDay = date.startOf('day');
    const endOfSMS = date.startOf('hour').add(1, 'hour');

    for (let i = startOfDay.hour(); i < endOfSMS.hour(); i++) {
      const start = startOfDay.add(i, 'hour');
      const end = start.clone().add(1, 'hour');

      const hours = start.hour() > 9 ? start.hour() : `0${start.hour()}`;
      const nextHours = end.hour() > 9 ? end.hour() : `0${end.hour()}`;
      const interval = `${hours}h-${nextHours}h`;

      getCountFromServer(
        query(
          smsCollection,
          where('created', '>=', start.toDate().getTime()),
          where('created', '<', end.toDate().getTime()),
          where('role', '==', 'assistant')
        )
      ).then((snapshot) => {
        const stat = stats[interval] || { planned: 0, sent: 0, received: 0 };
        stat.sent = snapshot.data().count || 0;
        stats[interval] = stat;
      });

      getCountFromServer(
        query(
          smsCollection,
          where('created', '>=', start.toDate().getTime()),
          where('created', '<', end.toDate().getTime()),
          where('role', '==', 'user')
        )
      ).then((snapshot) => {
        const stat = stats[interval] || { planned: 0, sent: 0, received: 0 };
        stat.received = snapshot.data().count || 0;
        stats[interval] = stat;
      });
    }

    return stats;
  } catch (e) {
    console.log('error: ', e);
    throw new GetSMSStatsFailure();
  }
}

export class GetSMSStatsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getSMSStats;
